import axios from 'axios'

/**
 * Fetches the list of artifacts for a specific workflow run from the GitHub Actions API.
 * @param runId {string} The ID of the workflow run.
 * @returns {Promise<object>} The response containing the list of artifacts or an error message.
 */
export default async function getArtifact(runId: string) {
  const { githubActionToken } = useRuntimeConfig().public
  const token = githubActionToken

  if (!token) {
    return {
      success: false,
      message: 'GITHUB_ACTION_TOKEN is not set in the .env file.',
    }
  }

  const url = `https://api.github.com/repos/hungryhub-team/hhvendor-automation/actions/runs/${runId}/artifacts`

  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/vnd.github.v3+json',
      },
    })

    return {
      success: true,
      data: response.data,
    }
  } catch (error) {
    const errResponse = (error as any).response
    return {
      success: false,
      message: errResponse?.data?.message || (error as Error).message || 'An unknown error occurred.',
    }
  }
}
